import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/Home'
import Modulos from '@/pages/Modulos'
import Assuntos from '@/pages/Assuntos'
import Apostila from '@/pages/Apostila'
import DispositivosLegais from '@/pages/DispositivosLegais'
import ExerciciosComplete from '@/pages/ExerciciosComplete'
import ExerciciosAssertivas from '@/pages/ExerciciosAssertivas'
import ExerciciosQuestoes from '@/pages/ExerciciosQuestoes'
import ExerciciosCompletePergunta from '@/pages/ExerciciosCompletePergunta'
import ExerciciosAssertivasPergunta from '@/pages/ExerciciosAssertivasPergunta'
import ExerciciosQuestoesPergunta from '@/pages/ExerciciosQuestoesPergunta'
import UsarComo from '@/pages/UsarComo'
const router = createRouter([Home, Modulos, Assuntos, Apostila, DispositivosLegais, ExerciciosComplete, ExerciciosAssertivas, ExerciciosQuestoes, ExerciciosCompletePergunta, ExerciciosAssertivasPergunta, ExerciciosQuestoesPergunta, UsarComo])

function scrollBehavior (to, from, savedPosition) {
  return new Promise(function (resolve, reject) {
    window.setTimeout(function () {
      if (savedPosition) {
        resolve(savedPosition)
      } else {
        resolve({ x: 0, y: 0 })
      }
    }, 500)
  })
}

function getRoute (component) {
  if (!component.route) {
    const json = JSON.stringify(component, null, 2)
    if (json && (json !== '{}')) {
      throw new Error('createRouter: route?' + json)
    } else {
      return
    }
  }
  if (!component.route.path) {
    const json = JSON.stringify(component.route, null, 2)
    throw new Error('createRouter: route.path?' + json)
  }
  component.route.name = component.route.name || component.route.path.split('/')[1]
  component.route.name = component.route.name || '/'
  const route = {
    path: component.route.path,
    name: component.route.name,
    meta: component.route.meta,
    component: component
  }
  return route
}

function createRouter (pages) {
  Vue.use(Router)
  const config = {
    scrollBehavior: scrollBehavior,
    routes: []
  }
  pages.map(function (page) {
    config.routes.push(getRoute(page))
  })
  const router = new Router(config)
  return router
}

export default router
